export const DISCLAIMER_TEST_ID = 'disclaimer';
